import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    rentGuaranteeFee: 30,
    monthlyRentAddFee: null,
    monthlyRentSubtractFee: null,
});

const rentGuarantee = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.RENT_GUARANTEE_UPDATE_MONTHLY_RENT:
            return {
                ...state,
                monthlyRent: payload,
            };
        case DispatchConstants.RENT_GUARANTEE_UPDATE_SECURITY_DEPOSIT:
            return {
                ...state,
                securityDeposit: payload,
            };
        default:
            return state;
    }
};

export default rentGuarantee;
